<template>
    <div class="body">
        <MenuPage></MenuPage>
        <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
            <div>
                <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                    fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

                <p>Cargando clientes</p>
            </div>
        </Dialog>
        <div class="content">
            <DataTable v-model:filters="filters" :value="clients" paginator :rows="7" dataKey="id" filterDisplay="row"
                scrollable scrollHeight="60vh">

                <template #header>
                    <div class="table-header">
                        <Button label="Agregar cliente" icon="pi pi-plus" class="p-button-success" @click="OpenModal" />
                    </div>
                </template>

                <Column header="Acciones">
                    <template #body="{ data }">
                        <Button type="button" icon="pi pi-ellipsis-v" @click="onButtonClick($event, data)"
                            aria-haspopup="true" aria-controls="overlay_menu" />
                        <Menu :model="items" :popup="true" v-model:popup="show" appendTo="body" ref="menuRef" />
                    </template>
                </Column>

                <!-- Columna: Nombre -->
                <Column field="rfc" header="RFC" style="min-width: 12rem" :filter="true" :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar RFC" />
                    </template>
                </Column>

                <!-- Columna: Correo -->
                <Column field="razon_social" header="Razon social" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar razon social" />
                    </template>
                </Column>

                <Column field="nombre_contacto" header="Nombre Contacto" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar razon social" />
                    </template>
                </Column>

                <Column field="correo_contacto" header="Correo Contacto" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar razon social" />
                    </template>
                </Column>

                <Column field="telefono_contacto" header="Telefono contacto" style="min-width: 12rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar razon social" />
                    </template>
                </Column>


            </DataTable>

            <Dialog v-model:visible="visible2" modal header="Editar Usuario" class="cont-50">

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on" class="cont-100">
                                <InputText id="on_label" class="cont-100" v-model="rfc" />
                                <label for="on_label">RFC</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="razon_social" />
                                <label for="on_label">Razon Social</label>
                            </FloatLabel>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="nombre_contacto" />
                                <label for="on_label">Nombre de contacto</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" type='number' class="cont-100" v-model="telefono_contacto" />
                                <label for="on_label">Telefono de contacto</label>
                            </FloatLabel>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="correo_contacto" />
                                <label for="on_label">Correo de contacto</label>
                            </FloatLabel>
                        </div>
                    </div>
                </div>


                <div class="d-block m-auto cont-95" style="margin-top: 12px;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="editContact()" type="button"
                        label="Editar" icon="pi pi-user-plus" :loading="isloading2" />
                </div>
            </Dialog>

            <Dialog v-model:visible="visible" modal header="Agregar Cliente" class="cont-50">

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on" class="cont-100">
                                <InputText id="on_label" class="cont-100" v-model="rfc" />
                                <label for="on_label">RFC</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="razon_social" />
                                <label for="on_label">Razon Social</label>
                            </FloatLabel>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="nombre_contacto" />
                                <label for="on_label">Nombre de contacto</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" type='number' class="cont-100" v-model="telefono_contacto" />
                                <label for="on_label">Telefono de contacto</label>
                            </FloatLabel>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="correo_contacto" />
                                <label for="on_label">Correo de contacto</label>
                            </FloatLabel>
                        </div>
                    </div>
                </div>


                <div class="d-block m-auto cont-95"
                    style="margin-top: 20px !important; margin-bottom: 20px  !important;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="addContact()" type="button"
                        label="Guardar" icon="pi pi-user-plus" :loading="isloading" />
                </div>
            </Dialog>

        </div>
    </div>
</template>


<script setup>
import api from '../plugins/axios';
import MenuPage from './MenuPage.vue';
import InputText from 'primevue/inputtext';
import { onMounted, ref } from 'vue';
import FloatLabel from 'primevue/floatlabel';
import Menu from 'primevue/menu';
import { Dialog, Column, DataTable, Button, ProgressSpinner } from 'primevue';
import { useToast } from 'vue-toastification';
import { nextTick } from 'vue';


const show = ref(false)
const visible = ref(false)
const visible2 = ref(false)
const menuRef = ref(null);
const rfc = ref("");
const correo_contacto = ref("");
const telefono_contacto = ref("");
const nombre_contacto = ref("");
const razon_social = ref("");
const isloading = ref(false);
const toast = useToast();
const clienteactual = ref([]);
const isloading2 = ref(false);

const filters = ref({
    global: { value: null },
    rfc: { value: null, matchMode: 'contains' },
    razon_social: { value: null, matchMode: 'contains' },
    nombre_contacto: { value: null, matchMode: 'contains' },
    correo_contacto: { value: null, matchMode: 'contains' },
    telefono_contacto: { value: null, matchMode: 'contains' },
});

const idcliente = ref(0);
const clients = ref([]);
const spinnervisible = ref(true);

const items = ref([
    {
        label: 'Options',
        items: [
            {
                label: 'Editar',
                icon: 'pi pi-user-edit',
                command: () => {
                    visible2.value = true;
                    idcliente.value = clienteactual.value.id;
                    rfc.value = clienteactual.value.rfc;
                    razon_social.value = clienteactual.value.razon_social;
                    correo_contacto.value = clienteactual.value.correo_contacto
                    telefono_contacto.value = clienteactual.value.telefono_contacto
                    nombre_contacto.value = clienteactual.value.nombre_contacto
                }
            },
            {
                label: 'Eliminar',
                icon: 'pi pi-trash',
                command: () => {
                    idcliente.value = clienteactual.value.id;
                    deleteContact();
                }
            }
        ]
    }
]);


const getClientes = async () => {
    try {
        const res = await api.get("/cliente/get");
        console.log(res.data)
        clients.value = res.data.data ?? [];
        nextTick(() => {
            spinnervisible.value = false;
        });
    }
    catch (err) {
        console.error(err);
    }
}



const OpenModal = () => {
    visible.value = true;
}


const addContact = async () => {
    isloading.value = true;
    try {
        if (validar()) {
            const res = await api.post("/cliente/save", {
                "rfc": rfc.value,
                "razon_social": razon_social.value,
                "nombre_contacto": nombre_contacto.value,
                "correo_contacto": correo_contacto.value,
                "telefono_contacto": telefono_contacto.value
            });
            console.log(res.data)
            if (res.data.status === "success") {

                setTimeout(() => {
                    rfc.value = "";
                    razon_social.value = "";
                    nombre_contacto.value = "";
                    correo_contacto.value = "";
                    telefono_contacto.value = "";
                    isloading.value = false;
                    visible.value = false;
                    getClientes();
                    toast.success('cliente agregado con exito');

                }, 1000);
            }
            else
            {
                isloading.value = false;
            }
        }
        else {
            isloading.value = false;
        }
    }
    catch (err) {
        console.error(err);
    }
}

const validar = () => {
    if (rfc.value === '') {
        toast.error("Campo de rfc requerido");
        return false;
    }
    else if (correo_contacto.value === "") {
        toast.error("Campo de correo requerido");
        return false;
    }
    else if (nombre_contacto.value === "") {
        toast.error("Campo de nombre requerido");
        return false;
    }
    else if (telefono_contacto.value === "") {
        toast.error("Campo de telefono requerido");
        return false;
    }
    else if (razon_social.value === "") {
        toast.error("Campo de razon_social requerido");
        return false;
    }
    else {
        return true;
    }
}
const editContact = async () => {
    isloading2.value = true;
    try {
        
        if (validar()) {
            
            const res = await api.post("/cliente/update", {
                "id": idcliente.value,
                "rfc": rfc.value,
                "razon_social": razon_social.value,
                "nombre_contacto": nombre_contacto.value,
                "correo_contacto": correo_contacto.value,
                "telefono_contacto": telefono_contacto.value
            });
            console.log(res)
            if (res.data.status === "success") {

                setTimeout(() => {
                    rfc.value = "";
                    razon_social.value = "";
                    nombre_contacto.value = "";
                    telefono_contacto.value = "";
                    correo_contacto.value = "";
                    isloading2.value = false;
                    visible2.value = false;
                    getClientes();
                    toast.success('Usuario editado con exito');

                }, 1000);
            }
        }
        else {
            isloading2.value = false;
        }
    }
    catch (err) {
        console.error(err);
    }
}

const deleteContact = async () => {

    try {
        const res = await api.post("/cliente/destroy", {
            id: idcliente.value
        });
        console.log(res)
        if (res.data.status === "success") {
            toast.success("Cliente eliminado con exito");
            getClientes();
        }
    }
    catch (err) {
        console.error(err);
    }
}

const onButtonClick = (event, data) => {
    clienteactual.value = data;
    show.value = true
    menuRef.value?.toggle(event) // ahora el menú sabe dónde aparecer
}



onMounted(() => {
    getClientes();

});



</script>


<style scoped>
.customfilter {
    width: 100px;
    border-radius: 5px;
    text-align: center;
    padding: 2px;
}

.bg_admin {
    background: rgba(0, 136, 255, 0.362);
    color: rgb(0, 140, 255);
}

.bg_facturacion {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_operador {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}
</style>